const introspectionQueryResultData = {
  __schema: {
    types: [
      {
        kind: 'UNION',
        name: 'HomeMainSliderDynamicZone',
        possibleTypes: [
          {
            name: 'ComponentCarouselCarouselBgOverlay'
          },
          {
            name: 'ComponentCarouselCarouselClassic'
          }
        ]
      }
    ]
  }
};

export default introspectionQueryResultData;
